import type React from 'react';

import deFlag from '@/components/ui/flags/de.svg';
import gbFlag from '@/components/ui/flags/gb.svg';
import nlFlag from '@/components/ui/flags/nl.svg';

export type CountryCode = 'gb' | 'de' | 'nl';

const FLAG_MAP = {
  gb: gbFlag,
  de: deFlag,
  nl: nlFlag,
} as const satisfies Record<CountryCode, string>;

const Flag = ({ countryCode, ...props }: React.HTMLAttributes<HTMLImageElement> & { countryCode: CountryCode }) => {
  return <img {...props} src={FLAG_MAP[countryCode]} alt={`${countryCode.toUpperCase()} Flag`} />;
};
Flag.displayName = 'Flag';

export default Flag;
